import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import { BASE_URL, DASHBOARD, DASHBOARD_MEMBER, M_POST } from '@/utils/api';

@Module({ name: 'dashboard' })
export default class Dashboard extends VuexModule {
  dashboard: any = {};

  dashboardMember: any = {};

  dashboardNewDownline: any = {};

  @Mutation
  mutateDashboard(payload: any) {
    this.dashboard = payload;
  }

  @Mutation
  mutateDashboardMember(payload: any) {
    this.dashboardMember = payload;
  }

  @Action({ commit: 'mutateDashboard', rawError: true })
  async FetchDashboard(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + DASHBOARD,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch dashboard failed');
      return data?.data;
    } catch (err) {
      throw toError(err, 'Fetch dashboard failed');
    }
  }

  @Action({ commit: 'mutateDashboardMember', rawError: true })
  async FetchDashboardMember() {
    try {
      const { data } = await axios({
        url: BASE_URL + DASHBOARD_MEMBER,
        method: M_POST,
        data: {}
      });

      assertOk(data, 'Fetch dashboard member failed');
      return data?.data;
    } catch (err) {
      throw toError(err, 'Fetch dashboard member failed');
    }
  }
}
